import Modernizr from "./Modernizr";
import Navigation from "./Navigation";
import Header from "./Header";
import Slideshows from "./Slideshows";
import Iframes from "./Iframes";
import Analytics from "./Analytics";
import Mailchimp from "./Mailchimp";
import FAQ from "./FAQ";
import Settings from "./Settings";
import TopicExplore from "./TopicExplore";
import videojs from "video.js";
import Youtube from "videojs-youtube";
import imgix from "imgix.js";


(function () {
  new Modernizr();
  new Navigation();
  new Header();
  new Slideshows();
  new Mailchimp();
  new Iframes();
  new Analytics();
  new FAQ();
  new Settings();
  new TopicExplore();

  if(jQuery('#video-js-bg').length > 0) {
    var player = videojs('video-js-bg', {
      controls: false,
      autoplay: true,
      loop: true,
      muted: true,
      responsive: true,
      aspectRatio: '16:9',
      enablePrivacyEnhancedMode: true
    });
  }
  if(jQuery('.video-js.background-youtube-video-embed').length > 0) {
    jQuery('.video-js.background-youtube-video-embed').each(function() {
      var player = videojs(jQuery(this).attr('id'), {
        controls: false,
        autoplay: true,
        loop: true,
        muted: true,
        responsive: true,
        aspectRatio: '16:9',
        enablePrivacyEnhancedMode: true
      });
    });
  }
  if(jQuery('.video-js.youtube-video-embed').length > 0) {
    jQuery('.video-js.youtube-video-embed').each(function() {
      var player = videojs(jQuery(this).attr('id'), {
        controls: true,
        autoplay: false,
        modestbranding: true,
        loop: true,
        muted: false,
        responsive: true,
        aspectRatio: '16:9',
        enablePrivacyEnhancedMode: true
      });
    });
  }

  // lightbox.option({
  //   'resizeDuration': 200,
  //   'wrapAround': true
  // })

  jQuery(document).on('click', '.js-move-trigger', function() {
    var destination = jQuery(this).attr('href');
    var tolerance = 98;
    jQuery("html, body").animate({scrollTop: jQuery(destination).offset().top + tolerance}, 400);
    return false;
  });

  jQuery(document).on('click', '.to-top', function () {
    jQuery("html, body").animate({scrollTop: 0}, 400);
    return false;
  });

})(window);

// Notice Bar
jQuery(window).on('load', function() {
  if(jQuery('.notice_bar').length > 0) {
    var nb_height = jQuery('.notice_bar').height();
    var content = 0;
    jQuery('header.header').css('top', nb_height + 'px');
    jQuery('.mask').css('top', nb_height + 'px');
    if(!jQuery('body').hasClass('logged-in') && !jQuery('body').hasClass('siteorigin-panels')) {
      content = content + 30;
      jQuery('html').css('margin-top', content + 'px');
    }
    if(jQuery('body').hasClass('logged-in') && !jQuery('body').hasClass('home')) {
      content = content + 30;
    }
    if(jQuery('.slideshow--header').length > 0) {
      content = content + 8;
    }
    if(jQuery('.content').length > 0) {
      jQuery('.content').css('margin-top', content + nb_height + 'px');
    }
    

    // Scroll for menu
    jQuery(window).on('scroll', function() {
      if(nb_height - jQuery(window).scrollTop() > 0) {
        jQuery('header.header').css('top', nb_height - jQuery(window).scrollTop() + 'px');
        jQuery('footer.footer .mask').css('top', nb_height - jQuery(window).scrollTop() + 'px');
      }
      if (jQuery(window).scrollTop() > nb_height) {
        jQuery('header.header').css('top', '0px');
        jQuery('footer.footer .mask').css('top', '0px');
      } else {
      }
    });
  }
});
